import React, { Component } from 'react';
import {

} from "react-router-dom";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from '../../constant/Utils';
import Header from '../common/Header';
import Footer from '../common/Footer';

import Reference from './Reference';

import { postAeItem } from '../../redux/action';

import './ae.css'; 
import '../common/common.css'; 

import aeBanner from '../../images/aeBanner.png';
import gearrow1 from '../../images/gearrow_1.png';
import gearrow2 from '../../images/gearrow_2.png';
import gearrow3 from '../../images/gearrow_3.png';
import aePlay from '../../images/aePlay.png';

class AeManagementItem extends Component {

	constructor(props, context) {
	    super(props, context);
	    this.state = {
	    	res: {}
	    };	
    }

	componentWillMount() {
		
		let token = window.localStorage.getItem("token");
		if (!token) {
			window.location.href = "/login";
		}

	}

	componentDidMount() {


		const splits = window.location.href.split('/');
		const object = splits[splits.length - 1];
		if (object.length == 0) {
			return ""
		}

		postAeItem({ "moduleType": object }).then(res => {
			this.setState({ res: res.data })
		}, this);
	}	

	renderSubBodySubItem(sub) {
		switch(sub.type) {
			case "para":
				return (
					<p dangerouslySetInnerHTML={{ __html: sub.desc }} ></p>
				)

			case "remark":
				return (
					<div><span dangerouslySetInnerHTML={{ __html: sub.desc }}></span></div>
				);

			case "li":
				return (
					<ul>
						{
							sub.sub.map( lisub => {
								return (
									<li>
									  <elem dangerouslySetInnerHTML={{ __html: lisub.desc }}></elem>
										{
											(lisub.sub != null) ? (
												<ul className={lisub.class}>
													{
														lisub.sub.map( lli => {
															return (
																<li className={lli.class}>
																	<elem dangerouslySetInnerHTML={{ __html: lli.desc }}></elem>
																	{
																		(lli.sub != null) ? (
																			<ul>
																				{
																					lli.sub.map( llli => {
																						return (
																							<li className={llli.class}>
																								<elem dangerouslySetInnerHTML={{ __html: llli.desc }}></elem>
																							</li>
																						);
																					})
																				}
																			</ul>
																		) : ""
																	}
																</li>
															);
														})
													}
												</ul>
											) : ""
										}
									</li>
								);
							})
						}
					</ul>
				);

			case "table":
				switch(sub.tableType) {
					case "percent":
						return (
							<table className="halfWidth">
								<tr>
									<th dangerouslySetInnerHTML={{ __html: sub.name }}></th>
									<th>%</th>
								</tr>
								<tbody>
									{
										sub.items.map(item => {
											return (
												<tr>
													<td><elem dangerouslySetInnerHTML={{ __html: item.name }}></elem></td>
													<td><elem dangerouslySetInnerHTML={{ __html: item.percentage }}></elem></td>
												</tr>
											)
										})
									}
									<tr>
										<td></td>
										<td></td>
									</tr>
								</tbody>
							</table>
						);
					case "assessment":
						return (
							<table className="assessmentTable">
								<tr>
									<th colspan="2"></th>
								</tr>
								<tr>
									<th>Definition</th>
									<th dangerouslySetInnerHTML={{ __html: sub.name }}></th>
								</tr>
								<tr>
									<th colspan="2"></th>
								</tr>
								<tbody>
									<tr className="ctcae"><td colspan="2">CTCAE Grade</td></tr>
									<tr className="separatorTr">
										<td colspan="2"></td>
									</tr>
									{
										sub.items.map(item => {
											return (
												<tr>
													<td><elem dangerouslySetInnerHTML={{ __html: item.name }}></elem><img src={item.thumb} /></td>
													<td><elem dangerouslySetInnerHTML={{ __html: item.desc }}></elem></td>
												</tr>
											)
										})
									}
									<tr className="separatorTr">
										<td colspan="2"></td>
									</tr>
								</tbody>
							</table>
						);
					case "guideline":
						return (
							<table className="guideTable">
								<tr>
									<th>CTCAE Grade</th>
									<th>Toxicity Management</th>
								</tr>
								<tbody>
									{
										sub.items.map((item, idx) => {
											switch (item.key) {
												case "1":
													return (
														<tr>
															<td><elem>Grade 1 <br/> (mild)</elem><img src="/images/grade1.png" /></td>
															<td>
															{
																item.sub.map(it => {
																	switch(it.type) {
																		case "para":
																			return <p dangerouslySetInnerHTML={{ __html: it.desc }}></p>
																		case "li":
																			return <li><elem dangerouslySetInnerHTML={{ __html: it.desc }}></elem></li>
																		case "ul":
																			return (
																				<ul>
																					<li><elem dangerouslySetInnerHTML={{ __html: it.desc }}></elem>
																					<ul>
																						{
																							it.sub.map( li => {
																								return <li><elem dangerouslySetInnerHTML={{ __html: li.desc }}></elem></li>
																							})
																						}
																					</ul>
																					</li>
																				</ul>
																			);
																		default:
																			return "";
																	}
																})
															}
															</td>
														</tr>
													)
												case "2":
													return (
														<tr>
															<td><elem>Grade 2 <br/> (moderate)</elem><img src="/images/grade2.png" /></td>
															<td>
															{
																item.sub.map(it => {
																	switch(it.type) {
																		case "para":
																			return <p dangerouslySetInnerHTML={{ __html: it.desc }}></p>
																		case "li":
																			return <li><elem dangerouslySetInnerHTML={{ __html: it.desc }}></elem></li>
																		case "ul":
																			return (
																				<ul>
																					<li><elem dangerouslySetInnerHTML={{ __html: it.desc }}></elem>
																					<ul>
																						{
																							it.sub.map( li => {
																								return <li><elem dangerouslySetInnerHTML={{ __html: li.desc }}></elem></li>
																							})
																						}
																					</ul>
																					</li>
																				</ul>
																			);
																		default:
																			return "";
																	}
																})
															}
															</td>
														</tr>
													)
												case "3":
													return (
														<tr>
															<td><elem>Grade 3 <br/> (severe)</elem><img src="/images/grade3.png" /><elem>or <br/>Grade 4 <br/> (life threatening)</elem><img src="/images/grade4.png" /></td>
															<td>
															{
																item.sub.map(it => {
																	switch(it.type) {
																		case "para":
																			return <p dangerouslySetInnerHTML={{ __html: it.desc }}></p>
																		case "li":
																			return <li><elem dangerouslySetInnerHTML={{ __html: it.desc }}></elem></li>
																		case "ul":
																			return (
																				<ul>
																					<li><elem dangerouslySetInnerHTML={{ __html: it.desc }}></elem>
																					<ul>
																						{
																							it.sub.map( li => {
																								return <li><elem dangerouslySetInnerHTML={{ __html: li.desc }}></elem></li>
																							})
																						}
																					</ul>
																					</li>
																				</ul>
																			);
																		default:
																			return "";
																	}
																})
															}
															</td>
														</tr>
													)
												default:
													return ""
											}
											
										})
									}
									<tr className="separatorTr">

									</tr>
								</tbody>
							</table>
						);
					case "dose_lvef":
						return (
							<table className="doseTable">
								<tr>
									<th colspan="2">Worst Toxicity CTCAE v5.0 Grade <br/> (Unless OtherwiseSpecified)</th>
									<th>Dose or Schedule Modification for Trastuzumab Deruxtecan</th>
								</tr>
									{
										sub.items.map(item => {
											return (
												<tbody>
													<tr className="separatorTr"><td colspan="3"></td></tr>
													<tr>
														<td colspan={ (item.child) ? "1": "2" }><elem dangerouslySetInnerHTML={{ __html: item.name }}></elem></td>
														{ (item.child) ? <td><elem dangerouslySetInnerHTML={{ __html: item.child }}></elem></td> : "" }
														<td>
														{
															item.sub.map(it => {
																return <li><elem dangerouslySetInnerHTML={{ __html: it.desc }}></elem></li>
															})
														}
														</td>
													</tr>
													<tr className="separatorTr"></tr>
												</tbody>
											);
										})
									}
									
									<tr className="separatorTr"><td colspan="3"></td></tr>
							</table>
						);
					case "dose":
						return (
							<table className="doseModiTable">
								<tr>
									<th>Worst Toxicity CTCAE v5.0 Grade <br/> (Unless OtherwiseSpecified)</th>
									<th>Dose or Schedule Modification for Trastuzumab Deruxtecan</th>
								</tr>
								<tbody>
									{
										sub.items.map(item => {
											return (
													<tr>
														<td><elem dangerouslySetInnerHTML={{ __html: item.name }}></elem>{ (item.thumb) ? <img src={item.thumb} /> : "" }</td>
														<td>
														{
															item.sub.map(it => {
																if (it.type == "para") return <p><elem dangerouslySetInnerHTML={{ __html: it.desc }}></elem></p>
																return <li><elem dangerouslySetInnerHTML={{ __html: it.desc }}></elem></li>
															})
														}
														</td>
													</tr>
											);
										})
									}
									
									<tr className="separatorTr"><td colspan="2"></td></tr>
								</tbody>
							</table>
						);
					default:
						return "";
				}
			case "program":
				return (
					<div className="secondaryBackground">
						<h3 dangerouslySetInnerHTML={{ __html: sub.name }}></h3>
						{
							sub.sub.map(subItem => {
								return (
									<div>
										<div className="subHeader"><h3>{subItem.title}</h3></div>
										<div className="subBody">
											<h3 dangerouslySetInnerHTML={{ __html: subItem.name }}></h3>
											{
												subItem.sub.map(item => {
													switch(item.type) {
														case "para":
															return <p dangerouslySetInnerHTML={{ __html: item.desc }}></p>
														case "li":
															return <li><elem dangerouslySetInnerHTML={{ __html: item.desc }}></elem></li>
														case "ul":
															return (
																<ul>
																	<li><elem dangerouslySetInnerHTML={{ __html: item.desc }}></elem>
																	<ul>
																		{
																			item.sub.map( li => {
																				return <li><elem dangerouslySetInnerHTML={{ __html: li.desc }}></elem></li>
																			})
																		}
																	</ul>
																	</li>
																</ul>
															);
														default:
															return "";
													}
												})
											}
										</div>
									</div>
								)
							})
						}
					</div>
				);
			case "roundCorner":
				return (
					<div className="roundCornerRemark centerAlign">
						<p>
							<elem dangerouslySetInnerHTML={{ __html: sub.desc }}></elem>
						</p>
					</div>
				);
			default:
				return ""

		}
	}

	renderSubBodyItem(section) {

		
		return (
			<div>
				<div className="subBodyItem">
					{
						(section.header) ? <h3 dangerouslySetInnerHTML={{ __html: section.header }}></h3> : ""
					}
					{
						(section.sub || []).map(sub => {
							return this.renderSubBodySubItem(sub)
						})
					}
				</div>
			</div>
		);
		
	}


	render() {


		const json = 
		[
			{
				title: "Interstitial lung disease/pneumonitis",
				key: "pneumonitis",
				sections: [
					{
						header: "ILD incidence in pooled analysis (N=234) of DESTINY-Breast01 and DS8201-A-J101<sup>1</sup>",
						sub: [
							{
								type: "table",
								tableType: "percent",
								name: "Incidence",
								items: [
									{ name: "All grades<sup>a</sup>", percentage: "13.7" },
									{ name: "Grades ≥ 3", percentage: "3.0" }
								]
							},
							{
								type: "para",
								desc: "Median time to first onset was 134 days (approximately 4.5 months); range: 35-338 days"
							},
							{
								type: "remark",
								desc: "<sup>a</sup>As defined by CTCAE, Common Terminology Criteria for Adverse Events, a grading scale established by the US National Cancer Institute (NCI)."
							},
							{
								type: "li",
								sub: [
									{
										desc: "There were no grade 4 or 5 adjudicated drug-related ILD/pneumonitis events in DESTINY-Breast03<sup>2</sup>"
									},
									{
										desc: "Cases of T-DXd–related ILD/pneumonitis have also been reported from a pooled analysis of 3 single-arm studies of trastuzumab deruxtecan following ≥ 2 lines of prior anti-HER2 therapy. The pooled studies with enrollment between 2015-2018 included DS8201-A-J101 (n = 50), DS8201-A-A104 (n = 11), and DESTINY-Breast01 (n = 184; June 8, 2020 data cutoff)<sup>3</sup>",
										sub: [
											{ 
												class: "yellow",
												desc: "Of patients with ILD/pneumonitis, 79% had grade 1 or 2 events (30/38 patients with ILD)" 
											},
											{ 
												class: "yellow",
												desc: "Grade 5 cases of ILD/pneumonitis occurred in 2.4% of patients (6/245)" 
											}
										]
									}
								]
							}
						]
					},
					{
						header: "Assessment of ILD/Pneumonitis<sup>4</sup>",
						sub: [
							{
								type: "table",
								tableType: "assessment",
								name: "A disorder characterized by inflammation focally or diffusely affecting the lung parenchyma",
								items: [
									{ name: "Grade 1 <br/> (mild)", thumb: "/images/grade1.png" , desc: "Asymptomatic; clinical or diagnostic observations only; intervention not indicated" },
									{ name: "Grade 2 <br/> (moderate)", thumb: "/images/grade2.png" , desc: "Symptomatic; medical intervention indicated; limiting instrumental ADL" },
									{ name: "Grade 3 <br/> (severe)", thumb: "/images/grade3.png" , desc: "Severe symptoms; limiting self-care ADL; oxygen indicated" },
									{ name: "Grade 4 <br/> (life threatening)", thumb: "/images/grade4.png" , desc: "Life-threatening respiratory compromise; urgent intervention indicated (eg, tracheotomy or intubation)" },
									{ name: "Grade 5", thumb: "/images/grade5.png" , desc: "Death" }
								]
							},
							{
								type: "remark",
								desc: "ADL, activities of daily living; CTCAE, Common Terminology Criteria for Adverse Events."
							},
							{
								type: "program",
								name: "ILD management program for trastuzumab deruxtecan<sup>5</sup>",
								sub: [
									{
										title: "Step 1: Monitor",
										name: "Suspected ILD/pneumonitis <img src='/images/programArrow.png' /> Interrupt drug",
										sub: [{
											type: "para", desc: "Rule out ILD/pneumonitis if a patient develops radiographic changes potentially consistent with ILD/pneumonitis or develops an acute onset of new or worsening pulmonary or other related signs/symptoms such as dyspnea, cough, or fever."
										}]
									},
									{
										title: "Step 2: Confirm",
										name: "Evaluations should include:",
										sub: [
											{ type: "li", desc: "High resolution CT" },
											{ type: "li", desc: "Pulmonologist consultation (infectious disease consultation as clinically indicated)" },
											{ type: "li", desc: "Blood culture and CBC. Other blood tests could be considered as needed" },
											{ type: "li", desc: "Consider bronchoscopy and bronchoalveolar lavage if clinically indicated and feasible" },
											{ type: "li", desc: "PFTs and pulse oximetry" },
											{ type: "li", desc: "Arterial blood gases if clinically indicated" },
											{ type: "li", desc: "One blood sample collection for PK analysis as soon as ILD/pneumonitis is suspected, if feasible" },
											{ type: "li", desc: "Other tests should be considered, as needed" },
											{ type: "para", desc: "All events of ILD, regardless of severity or seriousness, should be followed until resolution including after drug discontinuation." },
										]
									},
									{
										title: "Step 3: Manage",
										name: "Drug must be interrupted for any ILD events regardless of grade",
										sub: [
											{ type: "ul", desc: "<b>Grade 1:</b> Interrupt until fully resolved, then", sub: [
												{ type: "li", desc: "If resolved in 28 days or less from date of onset, maintain dose" },
												{ type: "li", desc: "If resolved in greater than 28 days from date of onset, reduce dose one level" },
												{ type: "li", desc: "However, if the event grade 1 ILD/pneumonitis occurs beyond cycle day 22 and has not resolved within 49 days from the last infusion, the drug should be discontinued" }
											] },
											{ type: "li", desc: "<b>Grades 2-4:</b> Permanently discontinue treatment. Refer to Toxicity Management Guidelines for Trastuzumab Deruxtecan" }
										]
									},
								]
							},
							{
								type: "remark",
								desc: "CBC, complete blood count; CT, computer tomography; PFT, pulmonary function test; PK, pharmacokinetic."
							},
						]
					},
					{
						header: "ILD Management Guidelines for Trastuzumab Deruxtecan<sup>5</sup>",
						sub: [
							{
								type: "table",
								tableType: "guideline",
								items: [
									{ key: "1", sub: [
										{ type: "para", desc: "Interrupt treatment for any ILD/pneumonitis events regardless of grade" },
										{ type: "li", desc: "Monitor and closely follow up in 2 to 7 days for onset of clinical symptoms and pulse oximetry" },
										{ type: "li", desc: "Consider follow-up imaging in 1-2 weeks (or as clinically indicated)" },
										{ type: "li", desc: "Consider starting systemic glucocorticoids (eg, at least 0.5 mg/kg/d prednisone or equivalent) until improvement, followed by gradual taper over at least 4 weeks" },
										{ type: "li", desc: "If worsening of diagnostic observations despite initiation of glucocorticoids, then follow grade 2 guidelines<sup>a</sup>" }
									] },
									{ key: "2", sub: [
										{ type: "para", desc: "Permanently discontinue treatment" },
										{ type: "li", desc: "Promptly start and treat with systemic glucocorticoids (eg, at least 1 mg/kg/d prednisone or equivalent) for at least 14 days or until complete resolution of clinical and chest CT findings, then followed by gradual taper over at least 4 weeks" },
										{ type: "li", desc: "Monitor symptoms closely" },
										{ type: "li", desc: "Reimage as clinically indicated" },
										{ type: "ul", desc: "If worsening or no improvement in clinical or diagnostic observations in 5 days,", sub: [
											{ type: "li", desc: "Consider increasing dose of glucocorticoids (eg, 2 mg/kg/d prednisone or equivalent) and administration may be switched to IV (eg, methylprednisolone)" },
											{ type: "li", desc: "Reconsider additional workup for alternative etiologies asdescribed above" },
											{ type: "li", desc: "Escalate care as clinically indicated" }
										] }
									] },
									{ key: "3", sub: [
										{ type: "para", desc: "Permanently discontinue treatment" },
										{ type: "li", desc: "Hospitalization required" },
										{ type: "li", desc: "Promptly initiate empiric high-dose methylprednisolone IV treatment (eg, 500-1000 mg/d for 3 days), followed by at least 1.0 mg/kg/d of prednisone (or equivalent) for at least 14 days or until complete resolution of clinical and chest CT findings, then followed by gradual taper over at least 4 weeks" },
										{ type: "li", desc: "Reimage as clinically indicated" },
										{ type: "ul", desc: "If still no improvement within 3 to 5 days,", sub: [
											{ type: "li", desc: "Reconsider additional workup for alternative etiologies as described above" },
											{ type: "li", desc: "Reconsider additional workup for alternative etiologies as described above" }
										] }
									] },
									
								]
							},
							{
								type: "remark",
								desc: "CTCAE, Common Terminology Criteria for Adverse Events; IV, intravenous."
							},
							{
								type: "remark",
								desc: "<sup>a</sup>If patient is asymptomatic, then patient should still be considered as grade 1 even if glucocorticoid treatment is given."
							},
						]
					},
					{
						header: "ILD disease background and signs/symptoms",
						sub: [
							{
								type: "para",
								desc: "ILD is a broad term for a group of diffuse, parenchymal lung disorders that present as nonspecific cough, fever, and shortness of breath (dyspnea), including pneumonitis and idiopathic pulmonary fibrosis (unknown cause).6-9 ILD is marked by the presence of inflammation or scarring of the lung interstitium and characterized by<sup>10</sup>"
							},
							{
								type: "li",
								sub: [
									{
										desc: "High resolution CT"
									},
									{
										desc: "Pulmonologist consultation (infectious disease consultation as clinically indicated)"
									},
									{
										desc: "Blood culture and CBC. Other blood tests could be considered as needed"
									},
									{
										desc: "Consider bronchoscopy and bronchoalveolar lavage if clinically indicated and feasible"
									},
									{
										desc: "PFTs and pulse oximetry"
									},
									{
										desc: "Arterial blood gases if clinically indicated"
									},
									{
										desc: "One blood sample collection for PK analysis as soon as ILD is suspected if feasible"
									}
								]
							},
							{
								type: "para",
								desc: "ILD is a result of several different conditions but is often associated with drug or chemical exposure.10 Several classes of anticancer agents increase the risk of ILD, including irinotecan and targeted therapies such as trastuzumab, T-DM1, and lapatinib.<sup>11-13</sup>"
							},
							{
								type: "li",
								sub: [
									{
										desc: "Cases of T-DXd–related ILD/pneumonitis have also been reported from a pooled analysis of 3 single-arm studies of trastuzumab deruxtecan following ≥ 2 lines of prior anti-HER2 therapy. The pooled studies with enrollment between 2015-2018 included DS8201-A-J101 (n = 50), DS8201-A-A104 (n = 11), and DESTINY-Breast01 (n = 184; June 8, 2020 data cutoff)<sup>3</sup>",
										sub: [
											{ 
												class: "yellow",
												desc: "Of patients with ILD/pneumonitis, 79% had grade 1 or 2 events (30/38 patients with ILD)" 
											},
											{ 
												class: "yellow",
												desc: "Grade 5 cases of ILD/pneumonitis occurred in 2.4% of patients (6/245)" 
											}
										]
									}
								]
							},
							{
								type: "roundCorner",
								desc: "Advise patients to immediately report cough, dyspnea, fever, and/or any new or worsening respiratory symptoms<sup>1</sup>"
							}
						]
					},
					{
						header: "Risk factors for ILD/pneumonitis associated with trastuzumab deruxtecan",
						sub: [
							{
								type: "li",
								sub: [
									{
										desc: "In a pooled analysis of 245 patients with HER2 positive metastatic breast cancer who received ≥ 1 dose of trastuzumab deruxtecan across 3 phase 1 or 2 studies, treatment in Japan or moderate/severe renal impairment at baseline were identified as potential factors of interest. Caution should be used when interpreting potential factors of interest, given the small sample size and extensive prior treatment. Further evaluation in larger, randomized controlled trials will be needed to confirm these potential factors of interest<sup>15</sup>"
									},
									{
										desc: "The exact mechanisms via which trastuzumab deruxtecan may cause ILD/pneumonitis are not yet known<sup>16</sup>"
									}
								]
							},
							{
								type: "roundCorner",
								desc: "Monitor patients for signs and symptoms of ILD and initiate corticosteroid treatment if ILD is suspected<sup>1</sup>"
							}
						]
					},
					{
						header: "Diagnosing drug-induced ILD",
						sub: [
							{
								type: "para",
								desc: "Diagnosis of drug-induced ILD is made based on a holistic consideration of clinical symptoms, physical findings, detailed medical history, diagnostic imaging, lung function tests, and pathological findings17<sup>17</sup>"
							},
							{
								type: "li",
								sub: [
									{
										desc: "Differential diagnosis is key in treating drug-induced ILD<sup>17</sup>"
									},
									{
										desc: "Drug-induced ILD should be distinguished from exacerbation of an underlying pulmonary disease and pulmonary edema<sup>17</sup>"
									}
								]
							},
							{
								type: "roundCorner",
								desc: "Early diagnosis is key for managing cases of drug-induced ILD. Initiate corticosteroid treatment if ILD is suspected<sup>1,18</sup>"
							},
							{
								type: "roundCorner",
								desc: "Advise patients to report all suspected ARs<sup>1</sup>"
							}
						]
					},
				]
			},
			{
				title: "Left ventricular ejection fraction decrease",
				key: "lvef-decrease",
				sections: [
					{
						header: "LVEF decrease incidence in pooled analysis of DESTINY-Breast01 and DS8201-A-J101<sup>1</sup>",
						sub: [
							{
								type: "table",
								tableType: "percent",
								name: "Incidence",
								items: [
									{ name: "All grades<sup>a</sup>", percentage: "1.3" }
								]
							},
							{
								type: "remark",
								desc: "<sup>a</sup>As defined by CTCAE, Common Terminology Criteria for Adverse Events, a grading scale established by the US National Cancer Institute (NCI)."
							},
							{
								type: "li",
								sub: [
									{
										desc: "LVEF decrease has been observed with anti-HER2 therapies<sup>1</sup>"
									},
									{
										desc: "No decreases of LVEF to less than 40% were observed<sup>1</sup>"
									},
									{
										desc: "Treatment with trastuzumab deruxtecan has not been studied in patients with LVEF less than 50% prior to initiation of treatment<sup>1</sup>"
									},
									{
										desc: "LVEF should be assessed prior to initiation of trastuzumab deruxtecan and at regular intervals during treatment as clinically indicated<sup>1</sup>"
									},
									{
										desc: "LVEF decrease should be managed through treatment interruption or discontinuation<sup>1</sup>"
									}
								]
							}
						]
					},
					{
						header: "Assessment of LVEF Decrease Severity<sup>4</sup>",
						sub: [
							{
								type: "table",
								tableType: "assessment",
								name: "A disorder characterized by failure of the left ventricle to produce adequate output",
								items: [
									{ name: "Grade 1 <br/> (mild)", thumb: "/images/grade1.png" , desc: "-" },
									{ name: "Grade 2 <br/> (moderate)", thumb: "/images/grade2.png" , desc: "-" },
									{ name: "Grade 3 <br/> (severe)", thumb: "/images/grade3.png" , desc: "Symptomatic due to drop in ejection fraction responsive to intervention" },
									{ name: "Grade 4 <br/> (life threatening)", thumb: "/images/grade4.png" , desc: "Refractory or poorly controlled heart failure due to drop in ejection fraction; intervention such as ventricular assist device, intravenous vasopressor support, or heart transplant indicated" },
									{ name: "Grade 5", thumb: "/images/grade5.png" , desc: "Death" }
								]
							},
							{
								type: "remark",
								desc: "CTCAE, Common Terminology Criteria for Adverse Events."
							},
						]
					},
					{
						header: "Dose modifications for LVEF<sup>1</sup>",
						sub: [
							{
								type: "table",
								tableType: "dose_lvef",
								items: [
									{ name: "LVEF greater than 45% and absolute decrease from baseline is 10% to 20%",  sub: [
										{ desc: "Continue treatment with trastuzumab deruxtecan" }
									] },
									{ name: "LVEF <br/> 40% to 45%", child: "An absolute decrease <br/> from baseline is <10%", sub: [
										{ desc: "Continue treatment with trastuzumab deruxtecan" },
										{ desc: "Repeat LVEF assessment within 3 weeks" }
									] },
									{ name: "", child: "An absolute decrease <br/> from baseline is ≥20%",  sub: [
										{ desc: "Interrupt trastuzumab deruxtecan" },
										{ desc: "Repeat LVEF assessment within 3 weeks" },
										{ desc: "If LVEF has not recovered to within 10% from baseline, permanently discontinue trastuzumab deruxtecan" },
										{ desc: "If LVEF recovers to within 10% from baseline, resume trastuzumab deruxtecan at the same dose" }
									] },
									{ name: "LVEF <40% or absolute decrease from baseline is >20%",  sub: [
										{ desc: "Interrupt trastuzumab deruxtecan" },
										{ desc: "Repeat LVEF assessment within 3 weeks" },
										{ desc: "If LVEF of less than 40% or absolute decrease from baseline of greater than 20% is confirmed, permanently discontinue trastuzumab deruxtecan" }
									] },
									{ name: "Symptomatic congestive heart failure",  sub: [
										{ desc: "Permanently discontinue trastuzumab deruxtecan" }
									] },
								]
							},
							{
								type: "remark",
								desc: "CTCAE, Common Terminology Criteria for Adverse Events."
							},
						]
					},
					{
						header: "LVEF decrease management<sup>19</sup>",
						sub: [
							{
								type: "li",
								sub: [
									{
										desc: "Regular exercise is recommended, according to physician-directed prescription"
									},
									{
										desc: "Cessation of smoking"
									},
									{
										desc: "Alcohol abstinence if there is a current or previous history of excessive alcohol intake"
									},
									{
										desc: "For patients with hypertension, optimal blood pressure control is recommended"
									}
								]
							}
						]
					},
				]
			},
			{
				title: "Neutropenia<sup>1</sup>",
				key: "neutropenia",
				sections: [
					{
						header: "",
						sub: [
							{
								type: "li",
								sub: [
									{
										desc: "Cases of neutropenia, including febrile neutropenia, were reported in clinical studies of trastuzumab deruxtecan"
									},
									{
										desc: "Refer to the neutrophil count decreased section in this website for incidence, dose modification, and management"
									},
									{
										desc: "In a pooled analysis of 234 patients who received at least one dose of 5.4 mg/kg trastuzumab deruxtecan following ≥ 2 lines of prior anti-HER2 therapy in DESTINY-Breast01 and DS8201-A-J101, 1.7% of patients experienced febrile neutropenia"
									}
								]
							}
						]
					},
				]
			},
			{
				title: "Embryo-fetal toxicity<sup>1</sup>",
				key: "embryo-fetal",
				sections: [
					{
						header: "",
						sub: [
							{
								type: "li",
								sub: [
									{
										desc: "Trastuzumab deruxtecan can cause fetal harm when administered to a pregnant woman"
									},
									{
										desc: "The pregnancy status of females of reproductive potential should be verified prior to the initiation of trastuzumab deruxtecan"
									},
									{
										desc: "The patient should be informed of the potential risks to the fetus. Females of reproductive potential should be advised to use effective contraception during treatment and for at least 7 months following the last dose of trastuzumab deruxtecan"
									},
									{
										desc: "Male patients with female partners of reproductive potential should be advised to use effective contraception during treatment with trastuzumab deruxtecan and for at least 4 months after the last dose of trastuzumab deruxtecan"
									}
								]
							}
						]
					},
				]
			},
			{
				title: "Nausea",
				key: "nausea",
				sections: [
					{
						header: "Nausea incidence in pooled analysis of DESTINY-Breast01 and DS8201-A-J101<sup>2</sup>",
						sub: [
							{
								type: "table",
								tableType: "percent",
								name: "Incidence",
								items: [
									{ name: "All grades<sup>a</sup>", percentage: "79.9" },
									{ name: "Grades ≥ 3", percentage: "6.8" }
								]
							},
							{
								type: "remark",
								desc: "<sup>a</sup>As defined by CTCAE, Common Terminology Criteria for Adverse Events, a grading scale established by the US National Cancer Institute (NCI)."
							}
						]
					},
					{
						header: "Assessment of Nausea Severity<sup>4</sup>",
						sub: [
							{
								type: "table",
								tableType: "assessment",
								name: "A disorder characterized by a queasy sensation and/or the urge to vomit",
								items: [
									{ name: "Grade 1 <br/> (mild)", thumb: "/images/grade1.png" , desc: "Loss of appetite without alteration in eating habits" },
									{ name: "Grade 2 <br/> (moderate)", thumb: "/images/grade2.png" , desc: "Oral intake decreased without significant weight loss, dehydration, or malnutrition" },
									{ name: "Grade 3 <br/> (severe)", thumb: "/images/grade3.png" , desc: "Inadequate oral caloric or fluid intake; tube feeding, TPN, or hospitalization indicated" },
									{ name: "Grade 4 <br/> (life threatening)", thumb: "/images/grade4.png" , desc: "-" },
									{ name: "Grade 5", thumb: "/images/grade5.png" , desc: "-" }
								]
							},
							{
								type: "remark",
								desc: "CTCAE, Common Terminology Criteria for Adverse Events; TPN, total parenteral nutrition."
							},
						]
					},
					{
						header: "Dose modifications for Nausea<sup>1</sup>",
						sub: [
							{
								type: "table",
								tableType: "dose",
								items: [
									{ name: "Grade 3 <br/> (severe)", thumb: "/images/grade3.png" , sub: [
										{ type: "para", desc: "Delay dose until resolved to ≤ grade 1:" },
										{ type: "li", desc: "If resolved in ≤ 7 days from day of onset, maintain dose" },
										{ type: "li", desc: "If resolved in > 7 days from day of onset, reduce dose 1 level" }
									]}
								]
							},
							{
								type: "remark",
								desc: "CTCAE, Common Terminology Criteria for Adverse Events."
							}
						]
					},
					{
						header: "Nausea signs and symptoms",
						sub: [
							{
								type: "li",
								sub: [
									{
										desc: "Nausea is an unpleasant, queasy sensation in the stomach possibly accompanied by the urge to vomit<sup>4</sup>"
									}
								]
							}
						]
					},
					{
						header: "Nausea management",
						sub: [
							{
								type: "li",
								sub: [
									{
										desc: "Treatment of nausea remains a challenge, and nausea is typically managed through the control of vomiting with antiemetics.20 For details, please see the “Vomiting Management” section in this website"
									},
									{
										desc: "Consult your local practice guidelines and/or consider Multinational Association for Supportive Care in Cancer™ (MASCC) recommended guidelines"
									}
								]
							}
						]
					},
					{
						header: "Tips for your patients<sup>21,22</sup>",
						sub: [
							{
								type: "li",
								sub: [
									{
										desc: "Eat small meals throughout the day"
									},
									{
										desc: "Avoid foods that can cause nausea (eg, greasy or strong-smelling foods)"
									},
									{
										desc: "Eat food at room temperature"
									},
									{
										desc: "Drink plenty of water and other fluids. Drink slowly or in small sips using a straw if necessary (eg, ginger ale)"
									},
									{
										desc: "Talk to a registered dietitian or qualified nutritionist who knows how to take care of patients with cancer"
									},
								]
							}
						]
					},
				]
			},
			{
				title: "Vomiting",
				key: "vomiting",
				sections: [
					{
						header: "Vomiting incidence in pooled analysis of DESTINY-Breast01 and DS8201-A-J101<sup>2</sup>",
						sub: [
							{
								type: "table",
								tableType: "percent",
								name: "Incidence",
								items: [
									{ name: "All grades<sup>a</sup>", percentage: "48.7" },
									{ name: "Grades ≥ 3", percentage: "4.3" }
								]
							},
							{
								type: "remark",
								desc: "<sup>a</sup>As defined by CTCAE, Common Terminology Criteria for Adverse Events, a grading scale established by the US National Cancer Institute (NCI)."
							}
						]
					},
					{
						header: "Assessment of Vomiting Severity<sup>4</sup>",
						sub: [
							{
								type: "table",
								tableType: "assessment",
								name: "A disorder characterized by the reflexive act of ejecting the contents of the stomach through the mouth",
								items: [
									{ name: "Grade 1 <br/> (mild)", thumb: "/images/grade1.png" , desc: "Intervention not indicated" },
									{ name: "Grade 2 <br/> (moderate)", thumb: "/images/grade2.png" , desc: "Outpatient IV hydration; medical intervention indicated" },
									{ name: "Grade 3 <br/> (severe)", thumb: "/images/grade3.png" , desc: "Tube feeding, TPN, or hospitalization indicated" },
									{ name: "Grade 4 <br/> (life threatening)", thumb: "/images/grade4.png" , desc: "Life-threatening consequences" },
									{ name: "Grade 5", thumb: "/images/grade5.png" , desc: "Death" }
								]
							},
							{
								type: "remark",
								desc: "CTCAE, Common Terminology Criteria for Adverse Events; IV, intravenous; TPN, total parenteral nutrition."
							},
						]
					},
					{
						header: "Dose Modification for Other Nonlaboratory Events<sup>1</sup>",
						sub: [
							{
								type: "table",
								tableType: "dose",
								items: [
									{ name: "Grade 3 <br/> (severe)", thumb: "/images/grade3.png" , sub: [
										{ type: "para", desc: "Delay dose until resolved to ≤ grade 1:" },
										{ type: "li", desc: "If resolved in ≤ 7 days from day of onset, maintain dose" },
										{ type: "li", desc: "If resolved in > 7 days from day of onset, reduce dose 1 level" }
									]},
									{ name: "Grade 4 <br/> (life threatening)", thumb: "/images/grade4.png" , sub: [
										{ type: "para", desc: "Discontinue patient from study treatment" }
									]}
								]
							},
							{
								type: "remark",
								desc: "CTCAE, Common Terminology Criteria for Adverse Events."
							}
						]
					},
					{
						header: "Vomiting signs and symptoms",
						sub: [
							{
								type: "li",
								sub: [
									{
										desc: "Vomiting is the ejection of stomach contents through the mouth<sup>4</sup>"
									}
								]
							}
						]
					},
					{
						header: "Vomiting management",
						sub: [
							{
								type: "li",
								sub: [
									{
										desc: "A 5-HT3 receptor antagonist plus dexamethasone may be considered for the prophylaxis of acute nausea and vomiting<sup>20</sup>"
									},
									{
										desc: "For delayed nausea and vomiting, consider an antiemetic such as dexamethasone<sup>20</sup>"
									},
									{
										desc: "Consult your local practice guidelines"
									}
								]
							}
						]
					},
					{
						header: "Tips for your patients<sup>23</sup>",
						sub: [
							{
								type: "li",
								sub: [
									{
										desc: "For vomiting, lie on side to prevent inhalation of vomit. Try frozen liquids such as ice chips or frozen juice chips. Once vomiting stops, start taking in 1 teaspoon of cool liquids every 10 minutes, then advance to larger amounts of liquid after an hour or so"
									},
									{
										desc: "Refer to the management tips for nausea"
									},
									{
										desc: "If drinking or swallowing is not possible, call HCP immediately"
									}
								]
							}
						]
					},
				]
			},
			{
				title: "Constipation",
				key: "constipation",
				sections: [
					{
						header: "Constipation incidence in pooled analysis of DESTINY-Breast01 and DS8201-A-J101<sup>2</sup>",
						sub: [
							{
								type: "table",
								tableType: "percent",
								name: "Incidence",
								items: [
									{ name: "All grades<sup>a</sup>", percentage: "35.9" },
									{ name: "Grades ≥ 3", percentage: "0.9" }
								]
							},
							{
								type: "remark",
								desc: "<sup>a</sup>As defined by CTCAE, Common Terminology Criteria for Adverse Events, a grading scale established by the US National Cancer Institute (NCI)."
							}
						]
					},
					{
						header: "Assessment of Constipation Severity<sup>4</sup>",
						sub: [
							{
								type: "table",
								tableType: "assessment",
								name: "A disorder characterized by irregular and infrequent or difficult evacuation of the bowels",
								items: [
									{ name: "Grade 1 <br/> (mild)", thumb: "/images/grade1.png" , desc: "Occasional or intermittent symptoms; occasional use of stool softeners, laxatives, dietary modification, or enema" },
									{ name: "Grade 2 <br/> (moderate)", thumb: "/images/grade2.png" , desc: "Persistent symptoms with regular use of laxatives or enemas; limiting instrumental ADL" },
									{ name: "Grade 3 <br/> (severe)", thumb: "/images/grade3.png" , desc: "Obstipation with manual evacuation indicated; limiting self-care ADL" },
									{ name: "Grade 4 <br/> (life threatening)", thumb: "/images/grade4.png" , desc: "Life-threatening consequences; urgent intervention indicated" },
									{ name: "Grade 5", thumb: "/images/grade5.png" , desc: "Death" }
								]
							},
							{
								type: "remark",
								desc: "ADL, activities of daily living; CTCAE, Common Terminology Criteria for Adverse Events."
							},
						]
					},
					{
						header: "Dose Modification for Other Nonlaboratory Events<sup>1</sup>",
						sub: [
							{
								type: "table",
								tableType: "dose",
								items: [
									{ name: "Grade 3 <br/> (severe)", thumb: "/images/grade3.png" , sub: [
										{ type: "para", desc: "Delay dose until resolved to ≤ grade 1:" },
										{ type: "li", desc: "If resolved in ≤ 7 days from day of onset, maintain dose" },
										{ type: "li", desc: "If resolved in > 7 days from day of onset, reduce dose 1 level" }
									]},
									{ name: "Grade 4 <br/> (life threatening)", thumb: "/images/grade4.png" , sub: [
										{ type: "para", desc: "Discontinue patient from study treatment" }
									]}
								]
							},
							{
								type: "remark",
								desc: "CTCAE, Common Terminology Criteria for Adverse Events."
							}
						]
					},
					{
						header: "Constipation signs and symptoms",
						sub: [
							{
								type: "li",
								sub: [
									{
										desc: "Difficulty in passing usually dry, hardened stool, resulting in infrequent and possibly painful bowel movements<sup>4</sup>"
									}
								]
							}
						]
					},
					{
						header: "Constipation management",
						sub: [
							{
								type: "li",
								sub: [
									{
										class: "twoCol",
										desc: "Consider one or more laxatives and/or suppositories, including but not limited to<sup>24</sup>:",
										sub: [
											{ 
												class: "blue halfFloat",
												desc: "Psyllium" 
											},
											{ 
												class: "blue halfFloat",
												desc: "Senna" 
											},
											{ 
												class: "blue halfFloat",
												desc: "Bisacodyl" 
											},
											{ 
												class: "blue halfFloat",
												desc: "Docusate sodium" 
											},
											{ 
												class: "blue halfFloat",
												desc: "Glycerin suppository" 
											},
											{ 
												class: "blue halfFloat",
												desc: "Magnesium citrate" 
											},
											{ 
												class: "blue halfFloat",
												desc: "Magnesium hydroxide" 
											},
											{ 
												class: "blue halfFloat",
												desc: "Lactulose" 
											},
											{ 
												class: "blue halfFloat",
												desc: "Sorbitol and sodium phosphate" 
											},
										]
									},
									{
										desc: "Consult your local practice guidelines"
									}
								]
							}
						]
					},
					{
						header: "Tips for your patients<sup>23</sup>",
						sub: [
							{
								type: "li",
								sub: [
									{
										desc: "Ensure privacy and comfort to allow a patient to defecate<sup>25</sup>"
									},
									{
										desc: "Utilize positioning to aid with defecation (eg, assist gravity, small footstool may help exert pressure more easily)<sup>25</sup>"
									},
									{
										desc: "Increase fluid intake<sup>25</sup>"
									},
									{
										desc: "Eat foods that are high in fiber, such as fruits, vegetables, and whole-grain breads and cereals<sup>26</sup>"
									},
									{
										desc: "Encourage activity and increased mobility within patient limits<sup>25</sup>"
									},
									{
										desc: "Anticipatory management of constipation when certain medications are prescribed (eg, opioids)<sup>25</sup>"
									}
								]
							}
						]
					},
					{
						header: "Clinical Evaluation",
						sub: [
							{
								type: "li",
								sub: [
									{
										desc: "Evaluate concomitant medications that may contribute to constipation, including<sup>25,27</sup>:",
										sub: [
											{ 
												class: "blue halfFloat",
												desc: "Opiods" 
											},
											{ 
												class: "blue halfFloat",
												desc: "Anticholinergics (tricyclic antidepressants, phenothiazines)" 
											},
											{ 
												class: "blue halfFloat",
												desc: "Calcium- or aluminumcontaining antacids" 
											},
											{ 
												class: "blue halfFloat",
												desc: "Iron preparations" 
											},
											{ 
												class: "blue halfFloat",
												desc: "Antiemetics (5-HT3 antagonists)" 
											}
										]
									},
									{
										desc: "Consider use of prophylactic laxatives when such agents are taken on a routine basis<sup>27</sup>"
									}
								]
							}
						]
					},
				]
			},
			{
				title: "Decreased appetite (anorexia)",
				key: "appetite",
				sections: [
					{
						header: "Decreased appetite incidence in pooled analysis of DESTINY-Breast01 and DS8201-A-J101<sup>2</sup>",
						sub: [
							{
								type: "table",
								tableType: "percent",
								name: "Incidence",
								items: [
									{ name: "All grades<sup>a</sup>", percentage: "34.6" },
									{ name: "Grades ≥ 3", percentage: "1.3" }
								]
							},
							{
								type: "remark",
								desc: "<sup>a</sup>As defined by CTCAE, Common Terminology Criteria for Adverse Events, a grading scale established by the US National Cancer Institute (NCI)."
							}
						]
					},
					{
						header: "Assessment of Anorexia Severity<sup>4</sup>",
						sub: [
							{
								type: "table",
								tableType: "assessment",
								name: "A disorder characterized by a loss of appetite",
								items: [
									{ name: "Grade 1 <br/> (mild)", thumb: "/images/grade1.png" , desc: "Loss of appetite without alteration in eating habits" },
									{ name: "Grade 2 <br/> (moderate)", thumb: "/images/grade2.png" , desc: "Oral intake altered without significant weight loss or malnutrition; oral nutritional supplements indicated" },
									{ name: "Grade 3 <br/> (severe)", thumb: "/images/grade3.png" , desc: "Associated with significant weight loss or malnutrition (eg, inadequate oral caloric and/or fluid intake); tube feeding or TPN indicated" },
									{ name: "Grade 4 <br/> (life threatening)", thumb: "/images/grade4.png" , desc: "Life-threatening consequences; urgent intervention indicated" },
									{ name: "Grade 5", thumb: "/images/grade5.png" , desc: "Death" }
								]
							},
							{
								type: "remark",
								desc: "CTCAE, Common Terminology Criteria for Adverse Events; TPN, total parenteral nutrition."
							},
						]
					},
					{
						header: "Dose Modification for Other Nonlaboratory Events<sup>1</sup>",
						sub: [
							{
								type: "table",
								tableType: "dose",
								items: [
									{ name: "Grade 3 <br/> (severe)", thumb: "/images/grade3.png" , sub: [
										{ type: "para", desc: "Delay dose until resolved to ≤ grade 1:" },
										{ type: "li", desc: "If resolved in ≤ 7 days from day of onset, maintain dose" },
										{ type: "li", desc: "If resolved in > 7 days from day of onset, reduce dose 1 level" }
									]},
									{ name: "Grade 4 <br/> (life threatening)", thumb: "/images/grade4.png" , sub: [
										{ type: "para", desc: "Discontinue patient from study treatment" }
									]}
								]
							},
							{
								type: "remark",
								desc: "CTCAE, Common Terminology Criteria for Adverse Events."
							}
						]
					},
					{
						header: "Decreased appetite signs and symptoms<sup>4</sup>",
						sub: [
							{
								type: "li",
								sub: [
									{
										desc: "Eating less than normal or not eating at all. Weight loss may occur"
									}
								]
							}
						]
					},
					{
						header: "Consider Decreased appetite management",
						sub: [
							{
								type: "li",
								sub: [
									{
										desc: "Consider an appetite stimulant, including but not limited to<sup>33</sup>:",
										sub: [
											{ 
												class: "blue halfFloat",
												desc: "Megestrol acetate" 
											},
											{ 
												class: "blue halfFloat",
												desc: "Metoclopramide" 
											},
											{ 
												class: "blue halfFloat",
												desc: "Dronabinol" 
											},
											{ 
												class: "blue halfFloat",
												desc: "Steroids" 
											}
										]
									},
									{
										desc: "Consult your local practice guidelines"
									}
								]
							}
						]
					},
					{
						header: "Tips for your patients<sup>30</sup>",
						sub: [
							{
								type: "li",
								sub: [
									{
										desc: "Eat several small meals throughout the day<sup>34</sup>"
									},
									{
										desc: "Avoid drinking liquids with meals; drink liquids in between meals<sup>34</sup>"
									},
									{
										desc: "Make eating more enjoyable by listening to music, watching TV, or eating with company<sup>34</sup>"
									},
									{
										desc: "Be as physically active as possible<sup>34</sup>"
									},
									{
										desc: "Eat foods high in protein and/or calories, and keep these types of snacks on hand<sup>34</sup>"
									},
									{
										desc: "Eat favorite foods any time of day<sup>34</sup>"
									},
									{
										desc: "Consider consulting a registered dietitian<sup>35</sup>"
									},
									{
										desc: "If bowel movement occurs after infusion of trastuzumab deruxtecan, call an HCP"
									},
								]
							}
						]
					},
				]
			},
			{
				title: "Diarrhea",
				key: "diarrhea",
				sections: [
					{
						header: "Diarrhea incidence in pooled analysis of DESTINY-Breast01 and DS8201-A-J101<sup>2</sup>",
						sub: [
							{
								type: "table",
								tableType: "percent",
								name: "Incidence",
								items: [
									{ name: "All grades<sup>a</sup>", percentage: "30.8" },
									{ name: "Grades ≥ 3", percentage: "2.6" }
								]
							},
							{
								type: "remark",
								desc: "<sup>a</sup>As defined by CTCAE, Common Terminology Criteria for Adverse Events, a grading scale established by the US National Cancer Institute (NCI)."
							}
						]
					},
					{
						header: "Assessment of Diarrhea Severity<sup>4</sup>",
						sub: [
							{
								type: "table",
								tableType: "assessment",
								name: "A disorder characterized by an increase in frequency and/or loose or watery bowel movements",
								items: [
									{ name: "Grade 1 <br/> (mild)", thumb: "/images/grade1.png" , desc: "Increase of < 4 stools per day over baseline; mild increase in ostomy output compared with baseline" },
									{ name: "Grade 2 <br/> (moderate)", thumb: "/images/grade2.png" , desc: "Increase of 4-6 stools per day over baseline; moderate increase in ostomy output compared to baseline; limiting instrumental ADL" },
									{ name: "Grade 3 <br/> (severe)", thumb: "/images/grade3.png" , desc: "Increase of ≥ 7 stools per day over baseline; hospitalization indicated; severe increase in ostomy output compared to baseline; limiting self-care ADL" },
									{ name: "Grade 4 <br/> (life threatening)", thumb: "/images/grade4.png" , desc: "Life-threatening consequences; urgent intervention indicated" },
									{ name: "Grade 5", thumb: "/images/grade5.png" , desc: "Death" }
								]
							},
							{
								type: "remark",
								desc: "ADL, activities of daily living; CTCAE, Common Terminology Criteria for Adverse Events."
							},
						]
					},
					{
						header: "Dose Modification for Diarrhea<sup>1</sup>",
						sub: [
							{
								type: "table",
								tableType: "dose",
								items: [
									{ name: "Grade 3 <br/> (severe)", thumb: "/images/grade3.png" , sub: [
										{ type: "para", desc: "Delay dose until resolved to ≤ grade 1:" },
										{ type: "li", desc: "If resolved in ≤ 7 days from day of onset, maintain dose" },
										{ type: "li", desc: "If resolved in > 7 days from day of onset, reduce dose 1 level" }
									]},
									{ name: "Grade 4 <br/> (life threatening)", thumb: "/images/grade4.png" , sub: [
										{ type: "para", desc: "Discontinue patient from study treatment" }
									]}
								]
							},
							{
								type: "remark",
								desc: "CTCAE, Common Terminology Criteria for Adverse Events."
							}
						]
					},
					{
						header: "Diarrhea signs and symptoms<sup>4</sup>",
						sub: [
							{
								type: "li",
								sub: [
									{
										desc: "Passage of frequent stool, usually loose or watery in consistency"
									}
								]
							}
						]
					},
					{
						header: "Diarrhea management",
						sub: [
							{
								type: "li",
								sub: [
									{
										desc: "Consider over-the-counter and prescription antidiarrheal medications, including but not limited to<sup>28</sup>:",
										sub: [
											{ 
												class: "blue halfFloat",
												desc: "Over-the-counter antidiarrheal agents such as loperamide" 
											},
											{ 
												class: "blue halfFloat",
												desc: "Prescription medications:",
												sub: [
													{ 
														class: "blue halfFloat",
														desc: "Diphenoxylate–atropine sulfate" 
													},
													{ 
														class: "blue halfFloat",
														desc: "Tincture of opium" 
													}
												]
											}
										]
									},
									{
										desc: "Consult your local practice guidelines"
									}
								]
							}
						]
					},
					{
						header: "Tips for your patients<sup>29</sup>",
						sub: [
							{
								type: "li",
								sub: [
									{
										desc: "Drink a lot of liquids"
									},
									{
										desc: "Avoid milk or milk products if they make diarrhea worse. Yogurt and firm cheeses are okay"
									},
									{
										desc: "Reduce fatty foods"
									},
									{
										desc: "Avoid caffeine, alcohol, and tobacco"
									},
									{
										desc: "Be sure to consume enough potassium"
									},
									{
										desc: "Patients with diarrhea complicated by cramping, nausea, and vomiting should be evaluated by an HCP"
									}
								]
							}
						]
					},
				]
			},
			{
				title: "Anemia",
				key: "anemia",
				sections: [
					{
						header: "Anemia incidence in pooled analysis of DESTINY-Breast01 and DS8201-A-J101<sup>2</sup>",
						sub: [
							{
								type: "table",
								tableType: "percent",
								name: "Incidence",
								items: [
									{ name: "All grades<sup>a</sup>", percentage: "33.8" },
									{ name: "Grades ≥ 3", percentage: "9.0" }
								]
							},
							{
								type: "remark",
								desc: "<sup>a</sup>This category includes the preferred terms hemoglobin decreased, red blood cell count decreased, anemia, and hematocrit decreased"
							},
							{
								type: "remark",
								desc: "<sup>b</sup>As defined by CTCAE, Common Terminology Criteria for Adverse Events, a grading scale established by the US National Cancer Institute (NCI)."
							}
						]
					},
					{
						header: "Assessment of Anemia Severity<sup>4</sup>",
						sub: [
							{
								type: "table",
								tableType: "assessment",
								name: "A disorder characterized by a reduction in the amount of hemoglobin in 100 mL of blood. Signs and symptoms of anemia may include pallor of the skin and mucous membranes, shortness of breath, palpitations of the heart, soft systolic murmurs, lethargy, and fatigability",
								items: [
									{ name: "Grade 1 <br/> (mild)", thumb: "/images/grade1.png" , desc: "Hgb < LLN-10.0 g/dL; < LLN-6.2 mmol/L; < LLN-100 g/L" },
									{ name: "Grade 2 <br/> (moderate)", thumb: "/images/grade2.png" , desc: "Hgb < 10.0-8.0 g/dL; < 6.2-4.9 mmol/L; < 100-80 g/L" },
									{ name: "Grade 3 <br/> (severe)", thumb: "/images/grade3.png" , desc: "Hgb < 8.0 g/dL; < 4.9 mmol/L; < 80 g/L; transfusion indicated" },
									{ name: "Grade 4 <br/> (life threatening)", thumb: "/images/grade4.png" , desc: "Life-threatening consequences; urgent intervention indicated" },
									{ name: "Grade 5", thumb: "/images/grade5.png" , desc: "Death" }
								]
							},
							{
								type: "remark",
								desc: "ADL, activities of daily living; CTCAE, Common Terminology Criteria for Adverse Events."
							},
						]
					},
					{
						header: "Dose Modification for Anemia<sup>1</sup>",
						sub: [
							{
								type: "table",
								tableType: "dose",
								items: [
									{ name: "Grade 3 <br/> (severe)", thumb: "/images/grade3.png" , sub: [
										{ type: "para", desc: "Delay dose until resolved to ≤ grade 1:" },
										{ type: "li", desc: "If resolved in ≤ 7 days from day of onset, maintain dose" },
										{ type: "li", desc: "If resolved in > 7 days from day of onset, reduce dose 1 level" }
									]},
									{ name: "Grade 4 <br/> (life threatening)", thumb: "/images/grade4.png" , sub: [
										{ type: "para", desc: "Discontinue patient from study treatment" }
									]}
								]
							},
							{
								type: "remark",
								desc: "CTCAE, Common Terminology Criteria for Adverse Events."
							}
						]
					},
					{
						header: "Anemia signs and symptoms",
						sub: [
							{
								type: "li",
								sub: [
									{
										desc: "A decrease in the number of red blood cells, which carry oxygen to cells throughout the body<sup>30</sup>"
									},
									{
										desc: "Symptoms of anemia may include fast heartbeat, shortness of breath, chest pain, dizziness, pale skin, swelling in the hands/feet, and fatigue<sup>31</sup>"
									}
								]
							}
						]
					},
					{
						header: "Anemia management",
						sub: [
							{
								type: "li",
								sub: [
									{
										desc: "Consider medical interventions for low red blood cell counts, including but not limited to<sup>30</sup>:",
										sub: [
											{ 
												class: "blue halfFloat",
												desc: "Iron supplement" 
											},
											{ 
												class: "blue halfFloat",
												desc: "Multivitamin" 
											},
											{ 
												class: "blue halfFloat",
												desc: "High-protein diet" 
											},
											{ 
												class: "blue halfFloat",
												desc: "Red blood cell transfusion" 
											}
										]
									},
									{
										desc: "Consult a hematologist if epoetin alfa or darbepoetin is used"
									},
									{
										desc: "Consult your local practice guidelines"
									},
									{
										desc: "Follow-up tests per standard protocols"
									}
								]
							}
						]
					},
					{
						header: "Tips for your patients<sup>31</sup>",
						sub: [
							{
								type: "li",
								sub: [
									{
										desc: "Plan ahead and save energy for the most important activities"
									},
									{
										desc: "Balance rest and activities"
									},
									{
										desc: "Eat a balanced diet that includes protein (meat, fish, eggs, cheese, milk, nuts, peas, and beans)"
									},
									{
										desc: "Drink plenty of nonalcoholic liquids"
									}
								]
							}
						]
					},
				]
			},
			{
				title: "Neutrophil count decreased (neutropenia)",
				key: "nc-decrease",
				sections: [
					{
						header: "Incidence of neutrophil count decreased in pooled analysis of DESTINY-Breast01 and DS8201-A-J101<sup>2</sup>",
						sub: [
							{
								type: "table",
								tableType: "percent",
								name: "Incidence",
								items: [
									{ name: "All grades<sup>a</sup>", percentage: "32.5" },
									{ name: "Grades ≥ 3", percentage: "18.8" }
								]
							},
							{
								type: "remark",
								desc: "<sup>a</sup>This category includes the preferred terms neutrophil count decreased and neutropenia. Febrile neutropenia was uncommon and occurred in 0.8% of patients treated with trastuzumab deruxtecan."
							},
							{
								type: "remark",
								desc: "<sup>b</sup>As defined by CTCAE, Common Terminology Criteria for Adverse Events, a grading scale established by the US National Cancer Institute (NCI)."
							}
						]
					},
					{
						header: "Assessment of Neutropenia Severity<sup>4</sup>",
						sub: [
							{
								type: "table",
								tableType: "assessment",
								name: "A finding based on laboratory test results that indicate a decrease in number of neutrophils in a blood specimen",
								items: [
									{ name: "Grade 1 <br/> (mild)", thumb: "/images/grade1.png" , desc: "< LLN-1500 mm<sup>3</sup>; < LLN-1.5 x 10<sup>9</sup>/L" },
									{ name: "Grade 2 <br/> (moderate)", thumb: "/images/grade2.png" , desc: "< 1500-1000/mm<sup>3</sup>; < 1.5-1.0 x 10<sup>9</sup>/L" },
									{ name: "Grade 3 <br/> (severe)", thumb: "/images/grade3.png" , desc: "< 1000-500/mm<sup>3</sup>; < 1.0-0.5 x 10<sup>9</sup>/L" },
									{ name: "Grade 4 <br/> (life threatening)", thumb: "/images/grade4.png" , desc: "< 500/mm<sup>3</sup>; < 0.5 x 10<sup>9</sup>/L" },
									{ name: "Grade 5", thumb: "/images/grade5.png" , desc: "-" }
								]
							},
							{
								type: "remark",
								desc: "CTCAE, Common Terminology Criteria for Adverse Events; LLN, lower limit of normal."
							},
						]
					},
					{
						header: "Dose Modification for Neutrophil Count Decreased<sup>1</sup>",
						sub: [
							{
								type: "table",
								tableType: "dose",
								items: [
									{ name: "Grade 3 <br/> (severe)", thumb: "/images/grade3.png" , sub: [
										{ type: "para", desc: "Delay dose until resolved to ≤ grade 2, then maintain dose" }
									]},
									{ name: "Grade 4 <br/> (life threatening)", thumb: "/images/grade4.png" , sub: [
										{ type: "para", desc: "Delay dose until resolved to ≤ grade 2, reduce dose 1 level" }
									]}
								]
							},
							{
								type: "remark",
								desc: "CTCAE, Common Terminology Criteria for Adverse Events."
							}
						]
					},
					{
						header: "Dose Modification for Febrile Neutropenia<sup>1</sup>",
						sub: [
							{
								type: "table",
								tableType: "dose",
								items: [
									{ name: "Febrile neutropenia (absolute neutrophil count < 1 × 10<sup>9</sup>/L, fever > 38.3 °C or a sustained temperature of ≥ 38 °C for more than 1 hour)",  sub: [
										{ desc: "Delay dose until resolved, reduce dose by 1 level" }
									] }
								]
							},
							{
								type: "remark",
								desc: "CTCAE, Common Terminology Criteria for Adverse Events."
							}
						]
					},
					{
						header: "Neutropenia signs and symptoms",
						sub: [
							{
								type: "li",
								sub: [
									{
										desc: "A decrease in the number of neutrophils, a type of white blood cell that fights infection<sup>30</sup>"
									},
									{
										desc: "When white blood cell count is low, patients may not have the usual signs and symptoms of fighting infection, such as redness, swelling, pus, cough, etc<sup>30</sup>"
									}
								]
							}
						]
					},
					{
						header: "Neutropenia management",
						sub: [
							{
								type: "li",
								sub: [
									{
										desc: "Consider treatments to prevent white blood cell counts from falling too low, such as<sup>30</sup>:",
										sub: [
											{ 
												class: "blue halfFloat",
												desc: "Filgrastim" 
											},
											{ 
												class: "blue halfFloat",
												desc: "Peg-filgrastim" 
											},
											{ 
												class: "blue halfFloat",
												desc: "Sargramostim" 
											}
										]
									},
									{
										desc: "Antimicrobial medications may be prescribed to prevent specific infections, including but not limited to<sup>30</sup>:",
										sub: [
											{ 
												class: "blue halfFloat",
												desc: "Sulfamethoxazole-trimethoprim" 
											},
											{ 
												class: "blue halfFloat",
												desc: "Acyclovir" 
											},
											{ 
												class: "blue halfFloat",
												desc: "Fluconazole" 
											},
											{ 
												class: "blue halfFloat",
												desc: "Itraconazole" 
											}
										]
									},
									{
										desc: "Consult your local practice guidelines"
									},
									{
										desc: "Follow up with lab tests as part of standard protocol"
									}
								]
							}
						]
					},
					{
						header: "Tips for your patients<sup>30</sup>",
						sub: [
							{
								type: "li",
								sub: [
									{
										desc: "Be alert to any physical changes"
									},
									{
										desc: "Reduce the risk of infection by:",
										sub: [
											{ 
												class: "blue halfFloat",
												desc: "Washing hands frequently" 
											},
											{ 
												class: "blue halfFloat",
												desc: "Avoiding contact with people who are sick" 
											},
											{ 
												class: "blue halfFloat",
												desc: "Not having dental work done while neutrophil count is low" 
											}
										]
									},
									{
										desc: "Before taking prophylactic seasonal vaccines, consult HCP"
									}
								]
							}
						]
					},
				]
			},
			{
				title: "Platelet count decreased",
				key: "pc-decrease",
				sections: [
					{
						header: "Platelet count decreased incidence in pooled analysis of DESTINY-Breast01 and DS8201-A-J101<sup>2</sup>",
						sub: [
							{
								type: "table",
								tableType: "percent",
								name: "Incidence",
								items: [
									{ name: "All grades<sup>a</sup>", percentage: "23.1" },
									{ name: "Grades ≥ 3", percentage: "4.3" }
								]
							},
							{
								type: "remark",
								desc: "<sup>a</sup>This category includes platelet count decreased and thrombocytopenia."
							},
							{
								type: "remark",
								desc: "<sup>b</sup>As defined by CTCAE, Common Terminology Criteria for Adverse Events, a grading scale established by the US National Cancer Institute (NCI)."
							}
						]
					},
					{
						header: "Assessment of Platelet Count Decreased Severity<sup>4</sup>",
						sub: [
							{
								type: "table",
								tableType: "assessment",
								name: "A finding based on laboratory test results that indicate a decrease in number of platelets in a blood specimen",
								items: [
									{ name: "Grade 1 <br/> (mild)", thumb: "/images/grade1.png" , desc: "< LLN-75,000/mm<sup>3</sup>; < LLN-75.0 × 10<sup>9</sup>/L" },
									{ name: "Grade 2 <br/> (moderate)", thumb: "/images/grade2.png" , desc: "< 75,000-50,000/mm<sup>3</sup>; < 75.0-50.0 × 10<sup>9</sup>/L" },
									{ name: "Grade 3 <br/> (severe)", thumb: "/images/grade3.png" , desc: "< 50,000-25,000/mm<sup>3</sup>; < 50.0-25.0 × 10<sup>9</sup>/L" },
									{ name: "Grade 4 <br/> (life threatening)", thumb: "/images/grade4.png" , desc: "< 25,000/mm<sup>3</sup>; < 25.0 × 10<sup>9</sup>/L" },
									{ name: "Grade 5", thumb: "/images/grade5.png" , desc: "-" }
								]
							},
							{
								type: "remark",
								desc: "CTCAE, Common Terminology Criteria for Adverse Events; LLN, lower limit of normal."
							},
						]
					},
					{
						header: "Dose Modification for Platelet Count Decreased<sup>1</sup>",
						sub: [
							{
								type: "table",
								tableType: "dose",
								items: [
									{ name: "Grade 3 <br/> (severe)", thumb: "/images/grade3.png" , sub: [
										{ type: "para", desc: "Delay dose until resolved to ≤ grade 1:" },
										{ type: "li", desc: "If resolved in ≤ 7 days from day of onset, maintain dose" },
										{ type: "li", desc: "If resolved in > 7 days from day of onset, reduce dose 1 level" }
									]},
									{ name: "Grade 4 <br/> (life threatening)", thumb: "/images/grade4.png" , sub: [
										{ type: "para", desc: "Delay dose until resolved to ≤ grade 1, reduce dose 1 level" }
									]}
								]
							},
							{
								type: "remark",
								desc: "CTCAE, Common Terminology Criteria for Adverse Events."
							}
						]
					},
					{
						header: "Decreased platelet count signs and symptoms",
						sub: [
							{
								type: "li",
								sub: [
									{
										desc: "A decrease in the number of platelets, which are cells that normally help to clot blood and stop bleeding<sup>30</sup>"
									},
									{
										desc: "Symptoms of decreased platelet count may include bleeding from anywhere, blood in the stool or urine, new bruises, red dots on the skin, headaches, weakness, and joint or muscle pain<sup>32</sup>"
									}
								]
							}
						]
					},
					{
						header: "Decreased platelet count management",
						sub: [
							{
								type: "li",
								sub: [
									{
										desc: "Consider medical interventions for low platelet counts, such as<sup>30</sup>:",
										sub: [
											{ 
												class: "blue halfFloat",
												desc: "Oprelvekin" 
											},
											{ 
												class: "blue halfFloat",
												desc: "Platelet transfusion" 
											}
										]
									},
									{
										desc: "Consult your local practice guidelines"
									}
								]
							}
						]
					},
					{
						header: "Tips for your patients<sup>32</sup>",
						sub: [
							{
								type: "li",
								sub: [
									{
										desc: "Only shave with electric razors"
									},
									{
										desc: "Avoid contact sports or other activities that may lead to injury"
									},
									{
										desc: "Protect skin from cuts and scrapes"
									},
									{
										desc: "Use a soft toothbrush, and ask HCP about putting off flossing"
									},
									{
										desc: "Rinse bleeding gums with ice water"
									},
									{
										desc: "Avoid blowing nose or coughing with great force"
									},
									{
										desc: "Keep head level with or above heart by either lying flat or staying upright"
									},
									{
										desc: "Consider using a stool softener to avoid constipation and straining, but check with an HCP before taking laxatives"
									},
									{
										desc: "Avoid putting anything in rectum, such as suppositories, enemas, thermometers, etc"
									},
									{
										desc: "Avoid anti-inflammatory pain medicines like aspirin, naproxen, or ibuprofen, unless HCP recommends using them"
									},
									{
										desc: "Stay calm if bleeding starts. Sit or lie down and get help"
									},
								]
							}
						]
					},
				]
			},
			{
				title: "White blood cell count decreased",
				key: "wbcc-decrease",
				sections: [
					{
						header: "White blood cell count decreased incidence in pooled analysis of DESTINY-Breast01 and DS8201-A-J101<sup>2</sup>",
						sub: [
							{
								type: "table",
								tableType: "percent",
								name: "Incidence",
								items: [
									{ name: "All grades<sup>a</sup>", percentage: "23.1" },
									{ name: "Grades ≥ 3", percentage: "7.3" }
								]
							},
							{
								type: "remark",
								desc: "<sup>a</sup>This category includes the preferred terms white blood cell count decreased and leukopenia."
							},
							{
								type: "remark",
								desc: "<sup>b</sup>As defined by CTCAE, Common Terminology Criteria for Adverse Events, a grading scale established by the US National Cancer Institute (NCI)."
							}
						]
					},
					{
						header: "Assessment of White Blood Cell Count Decreased Severity<sup>4</sup>",
						sub: [
							{
								type: "table",
								tableType: "assessment",
								name: "A finding based on laboratory test results that indicate a decrease in number of white blood cells in a blood specimen",
								items: [
									{ name: "Grade 1 <br/> (mild)", thumb: "/images/grade1.png" , desc: "< LLN-3,000/mm<sup>3</sup>; < LLN-3.0 × 10<sup>9</sup>/L" },
									{ name: "Grade 2 <br/> (moderate)", thumb: "/images/grade2.png" , desc: "< 3,000-2,000/mm<sup>3</sup>; < 3.0-2.0 × 10<sup>9</sup>/L" },
									{ name: "Grade 3 <br/> (severe)", thumb: "/images/grade3.png" , desc: "< 2,000-1,000/mm<sup>3</sup>; < 2.0-1.0 × 10<sup>9</sup>/L" },
									{ name: "Grade 4 <br/> (life threatening)", thumb: "/images/grade4.png" , desc: "< 1,000/mm<sup>3</sup>; < 1.0 × 10<sup>9</sup>/L" },
									{ name: "Grade 5", thumb: "/images/grade5.png" , desc: "-" }
								]
							},
							{
								type: "remark",
								desc: "CTCAE, Common Terminology Criteria for Adverse Events; LLN, lower limit of normal."
							},
						]
					},
					{
						header: "Dose Modification for White Blood Cell Count decreased<sup>1</sup>",
						sub: [
							{
								type: "table",
								tableType: "dose",
								items: [
									{ name: "Grade 3 <br/> (severe)", thumb: "/images/grade3.png" , sub: [
										{ type: "para", desc: "Delay dose until resolved to ≤ grade 2, then maintain dose" }
									]},
									{ name: "Grade 4 <br/> (life threatening)", thumb: "/images/grade4.png" , sub: [
										{ type: "para", desc: "Delay dose until resolved to ≤ grade 2, reduce dose 1 level" }
									]}
								]
							},
							{
								type: "remark",
								desc: "CTCAE, Common Terminology Criteria for Adverse Events."
							}
						]
					},
					{
						header: "Decreased white blood cell count signs and symptoms<sup>30</sup>",
						sub: [
							{
								type: "li",
								sub: [
									{
										desc: "A decrease in the total number of white blood cells, which are cells that fight infection"
									},
									{
										desc: "When white blood cell count is low, patients may not have the usual signs and symptoms of a developing infection such as redness, swelling, pus formation, cough, etc"
									}
								]
							}
						]
					},
					{
						header: "Decreased white blood cell count management<sup>30</sup>",
						sub: [
							{
								type: "li",
								sub: [
									{
										desc: "Consider medical interventions for low white blood cell counts, such as<sup>30</sup>:",
										sub: [
											{ 
												class: "blue halfFloat",
												desc: "Sargramostim" 
											},
											{ 
												class: "blue halfFloat",
												desc: "Antimicrobial medications that may prevent specific infections" 
											}
										]
									},
									{
										desc: "Consult your local practice guidelines"
									}
								]
							}
						]
					},
					{
						header: "Tips for your patients<sup>30</sup>",
						sub: [
							{
								type: "li",
								sub: [
									{
										desc: "Be alert to any physical changes and report changes to HCP"
									},
									{
										desc: "Reduce risk of infection by:",
										sub: [
											{ 
												class: "blue halfFloat",
												desc: "Washing hands frequently" 
											},
											{ 
												class: "blue halfFloat",
												desc: "Avoiding contact with anyone who is sick" 
											},
											{ 
												class: "blue halfFloat",
												desc: "Avoid dental work while white blood cell count is low" 
											},
										]
									},
									{
										desc: "Before taking prophylactic seasonal vaccines or antimicrobial agents, consult HCP"
									},
								]
							}
						]
					},
				]
			},
			{
				title: "Fatigue",
				key: "fatigue",
				sections: [
					{
						header: "Fatigue incidence in pooled analysis of DESTINY-Breast01 and DS8201-A-J101<sup>2</sup>",
						sub: [
							{
								type: "table",
								tableType: "percent",
								name: "Incidence",
								items: [
									{ name: "All grades<sup>a</sup>", percentage: "60.3" },
									{ name: "Grades ≥ 3", percentage: "6.4" }
								]
							},
							{
								type: "remark",
								desc: "<sup>a</sup>This category includes the preferred terms fatigue, asthenia, and malaise."
							},
							{
								type: "remark",
								desc: "<sup>b</sup>As defined by CTCAE, Common Terminology Criteria for Adverse Events, a grading scale established by the US National Cancer Institute (NCI)."
							}
						]
					},
					{
						header: "Assessment of Fatigue Severity<sup>4</sup>",
						sub: [
							{
								type: "table",
								tableType: "assessment",
								name: "A disorder characterized by a state of generalized weakness with a pronounced inability to summon sufficient energy to accomplish daily activities",
								items: [
									{ name: "Grade 1 <br/> (mild)", thumb: "/images/grade1.png" , desc: "Fatigue relieved by rest" },
									{ name: "Grade 2 <br/> (moderate)", thumb: "/images/grade2.png" , desc: "Fatigue not relieved by rest; limiting instrumental ADL" },
									{ name: "Grade 3 <br/> (severe)", thumb: "/images/grade3.png" , desc: "Fatigue not relieved by rest; limiting self-care ADL" },
									{ name: "Grade 4 <br/> (life threatening)", thumb: "/images/grade4.png" , desc: "-" },
									{ name: "Grade 5", thumb: "/images/grade5.png" , desc: "-" }
								]
							},
							{
								type: "remark",
								desc: "ADL, activities of daily living; CTCAE, Common Terminology Criteria for Adverse Events."
							},
						]
					},
					{
						header: "Dose Modification for Other Nonlaboratory Events<sup>1</sup>",
						sub: [
							{
								type: "table",
								tableType: "dose",
								items: [
									{ name: "Grade 3 <br/> (severe)", thumb: "/images/grade3.png" , sub: [
										{ type: "para", desc: "Delay dose until resolved to ≤ grade 1 or baseline:" },
										{ type: "li", desc: "If resolved in ≤ 7 days from day of onset, maintain dose" },
										{ type: "li", desc: "If resolved in > 7 days from day of onset, reduce dose 1 level" },
									]},
									{ name: "Grade 4 <br/> (life threatening)", thumb: "/images/grade4.png" , sub: [
										{ type: "para", desc: "Discontinue patient from study treatment" }
									]}
								]
							},
							{
								type: "remark",
								desc: "CTCAE, Common Terminology Criteria for Adverse Events."
							}
						]
					},
					{
						header: "Fatigue signs and symptoms",
						sub: [
							{
								type: "li",
								sub: [
									{
										desc: "Generalized tiredness, weakness, and/or lack of energy that is not relieved by sleep<sup>36</sup>"
									}
								]
							}
						]
					},
					{
						header: "Fatigue management",
						sub: [
							{
								type: "li",
								sub: [
									{
										desc: "Although there is no single medication available to treat fatigue, consider medications to treat any underlying cause(s) of the patient’s fatigue<sup>36</sup>"
									},
									{
										desc: "Consult your local practice guidelines"
									}
								]
							}
						]
					},
					{
						header: "Tips for your patients<sup>37</sup>",
						sub: [
							{
								type: "li",
								sub: [
									{
										desc: "Stay active and get regular exercise"
									},
									{
										desc: "Eat a healthy diet and drink plenty of fluids"
									},
									{
										desc: "Sleep therapy (eg, avoid caffeine, keep naps short, have good sleep habits)"
									},
									{
										desc: "Behavioral techniques (eg, relaxation, social support, counseling)"
									},
									{
										desc: "Save energy and focus on tasks that are most important"
									},
									{
										desc: "Ask family and friends to help with tasks that may be tiring or difficult"
									},
									{
										desc: "Use activities that can provide a distraction or an escape from fatigue and help relax and focus attention elsewhere"
									}
								]
							}
						]
					},
				]
			},
			{
				title: "Alopecia",
				key: "alopecia",
				sections: [
					{
						header: "Alopecia incidence in pooled analysis of DESTINY-Breast01 and DS8201-A-J101<sup>2</sup>",
						sub: [
							{
								type: "table",
								tableType: "percent",
								name: "Incidence",
								items: [
									{ name: "All grades<sup>a</sup>", percentage: "46.2" },
									{ name: "Grades ≥ 3", percentage: "0.4<sup>b</sup>" }
								]
							},
							{
								type: "remark",
								desc: "<sup>a</sup>As defined by CTCAE, Common Terminology Criteria for Adverse Events, a grading scale established by the US National Cancer Institute (NCI)."
							},
							{
								type: "remark",
								desc: "<sup>b</sup>This Grade 3 event was reported by the investigator. Per CTCAE v5.0, the highest CTCAE grade for alopecia is Grade 2."
							}
						]
					},
					{
						header: "Assessment of Alopecia Severity<sup>4</sup>",
						sub: [
							{
								type: "table",
								tableType: "assessment",
								name: "A disorder characterized by a decrease in density of hair compared to normal for a given individual at a given age and body location",
								items: [
									{ name: "Grade 1 <br/> (mild)", thumb: "/images/grade1.png" , desc: "Hair loss of < 50% of normal for that individual that is not obvious from a distance but only on close inspection; a different hair style may be required to cover the hair loss, but it does not require a wig or hairpiece to camouflage" },
									{ name: "Grade 2 <br/> (moderate)", thumb: "/images/grade2.png" , desc: "Hair loss of ≥ 50% normal for that individual that is readily apparent to others; a wig or hairpiece is necessary if the patient desires to completely camouflage the hair loss; associated with psychosocial impact" },
									{ name: "Grade 3 <br/> (severe)", thumb: "/images/grade3.png" , desc: "-" },
									{ name: "Grade 4 <br/> (life threatening)", thumb: "/images/grade4.png" , desc: "-" },
									{ name: "Grade 5", thumb: "/images/grade5.png" , desc: "-" }
								]
							},
							{
								type: "remark",
								desc: "CTCAE, Common Terminology Criteria for Adverse Events."
							},
						]
					},
					{
						header: "Alopecia signs and symptoms",
						sub: [
							{
								type: "li",
								sub: [
									{
										desc: "Hair may thin or be completely lost from the scalp or anywhere else on the body<sup>38</sup>"
									}
								]
							}
						]
					},
					{
						header: "Alopecia  management",
						sub: [
							{
								type: "li",
								sub: [
									{
										desc: "Consider hair loss management techniques, such as<sup>38</sup>:",
										sub: [
											{ 
												class: "blue halfFloat",
												desc: "Scalp cooling caps (scalp hypothermia)" 
											},
											{ 
												class: "blue halfFloat",
												desc: "Pharmacological interventions: minoxidil, bimatoprost, and calcitriol" 
											},
										]
									},
									{
										desc: "Consult your local practice guidelines"
									}
								]
							}
						]
					},
					{
						header: "Tips for your patients<sup>39</sup>",
						sub: [
							{
								type: "li",
								sub: [
									{
										desc: "Can cut hair short or shave head even before hair loss occurs"
									},
									{
										desc: "Use wigs, caps, or other head coverings"
									},
									{
										desc: "If hair becomes very thin or falls out completely, protect skin on the scalp from heat, cold, and the sun"
									},
									{
										desc: "Hair loss may be slightly reduced by avoiding too much brushing or washing of hair"
									},
									{
										desc: "Try wearing a hairnet at night, or sleeping on a satin pillowcase"
									}
								]
							}
						]
					},
				]
			},
			{
				title: "Cough",
				key: "cough",
				sections: [
					{
						header: "Cough incidence in pooled analysis of DESTINY-Breast01 and DS8201-A-J101<sup>2</sup>",
						sub: [
							{
								type: "table",
								tableType: "percent",
								name: "Incidence",
								items: [
									{ name: "All grades<sup>a</sup>", percentage: "21.4" },
									{ name: "Grades ≥ 3", percentage: "0" }
								]
							},
							{
								type: "remark",
								desc: "<sup>a</sup>As defined by CTCAE, Common Terminology Criteria for Adverse Events, a grading scale established by the US National Cancer Institute (NCI)."
							}
						]
					},
					{
						header: "Assessment of Cough Severity<sup>4</sup>",
						sub: [
							{
								type: "table",
								tableType: "assessment",
								name: "A disorder characterized by sudden, often repetitive, spasmodic contraction of the thoracic cavity, resulting in violent release of air from the lungs and usually accompanied by a distinctive sound",
								items: [
									{ name: "Grade 1 <br/> (mild)", thumb: "/images/grade1.png" , desc: "Mild symptoms; nonprescription intervention indicated" },
									{ name: "Grade 2 <br/> (moderate)", thumb: "/images/grade2.png" , desc: "Moderate symptoms, medical intervention indicated; limiting instrumental ADL" },
									{ name: "Grade 3 <br/> (severe)", thumb: "/images/grade3.png" , desc: "Severe symptoms; limiting self-care ADL" },
									{ name: "Grade 4 <br/> (life threatening)", thumb: "/images/grade4.png" , desc: "-" },
									{ name: "Grade 5", thumb: "/images/grade5.png" , desc: "-" }
								]
							},
							{
								type: "remark",
								desc: "ADL, activities of daily living; CTCAE, Common Terminology Criteria for Adverse Events."
							},
						]
					},
					{
						header: "Dose modification for other non-laboratory events<sup>2</sup>",
						sub: [
							{
								type: "table",
								tableType: "dose",
								items: [
									{ name: "Grade 3 <br/> (severe)", thumb: "/images/grade3.png" , sub: [
										{ type: "para", desc: "Delay dose until resolved to ≤ grade 1 or baseline:" },
										{ type: "li", desc: "If resolved in ≤ 7 days from day of onset, maintain dose" },
										{ type: "li", desc: "If resolved in > 7 days from day of onset, reduce dose 1 level" },
									]},
									{ name: "Grade 4 <br/> (life threatening)", thumb: "/images/grade4.png" , sub: [
										{ type: "para", desc: "Discontinue patient from study treatment" }
									]}
								]
							},
							{
								type: "remark",
								desc: "CTCAE, Common Terminology Criteria for Adverse Events."
							}
						]
					},
					{
						header: "Cough signs and symptoms",
						sub: [
							{
								type: "li",
								sub: [
									{
										desc: "Cough is a sudden, noisy, and forceful expulsion of air from the chest, caused by irritation in the air passages, or by the reflex action of a nervous or gastric disorder<sup>41</sup>"
									},
									{
										desc: "Acute cough that starts suddenly and lasts less than 3 weeks. Persistent or chronic cough that lasts more than 8 weeks<sup>42</sup>"
									}
								]
							}
						]
					},
					{
						header: "Cough management",
						sub: [
							{
								type: "li",
								sub: [
									{
										desc: "Consider medications to minimize effects of cough, such as antitussives, expectorants, decongestants, and antihistamines<sup>41</sup>"
									},
									{
										desc: "Consult your local practice guidelines"
									}
								]
							}
						]
					},
					{
						header: "Tips for your patients<sup>42</sup>",
						sub: [
							{
								type: "li",
								sub: [
									{
										desc: "Avoid smoking and secondhand smoke"
									},
									{
										desc: "Stay hydrated, which helps thin mucus in the throat"
									},
									{
										desc: "Consider mild exercise to help open up airways"
									},
									{
										desc: "Try using cough drops"
									},
									{
										desc: "Try relaxation techniques, such as deep breathing"
									},
								]
							}
						]
					},
				]
			},
			{
				title: "ALT and AST increased",
				key: "atl",
				sections: [
					{
						header: "Cough incidence in pooled analysis of DESTINY-Breast01 and DS8201-A-J101<sup>2</sup>",
						sub: [
							{
								type: "table",
								tableType: "percent",
								name: "Incidence",
								items: [
									{ name: "All grades<sup>a</sup>", percentage: "21.4" },
									{ name: "Grades ≥ 3", percentage: "0" }
								]
							},
							{
								type: "remark",
								desc: "<sup>a</sup>As defined by CTCAE, Common Terminology Criteria for Adverse Events, a grading scale established by the US National Cancer Institute (NCI)."
							}
						]
					},
					{
						header: "Assessment of Cough Severity<sup>4</sup>",
						sub: [
							{
								type: "table",
								tableType: "assessment",
								name: "A disorder characterized by sudden, often repetitive, spasmodic contraction of the thoracic cavity, resulting in violent release of air from the lungs and usually accompanied by a distinctive sound",
								items: [
									{ name: "Grade 1 <br/> (mild)", thumb: "/images/grade1.png" , desc: "Mild symptoms; nonprescription intervention indicated" },
									{ name: "Grade 2 <br/> (moderate)", thumb: "/images/grade2.png" , desc: "Moderate symptoms, medical intervention indicated; limiting instrumental ADL" },
									{ name: "Grade 3 <br/> (severe)", thumb: "/images/grade3.png" , desc: "Severe symptoms; limiting self-care ADL" },
									{ name: "Grade 4 <br/> (life threatening)", thumb: "/images/grade4.png" , desc: "-" },
									{ name: "Grade 5", thumb: "/images/grade5.png" , desc: "-" }
								]
							},
							{
								type: "remark",
								desc: "ADL, activities of daily living; CTCAE, Common Terminology Criteria for Adverse Events."
							},
						]
					},
					{
						header: "Dose modification for other non-laboratory events<sup>2</sup>",
						sub: [
							{
								type: "table",
								tableType: "dose",
								items: [
									{ name: "Grade 3 <br/> (severe)", thumb: "/images/grade3.png" , sub: [
										{ type: "para", desc: "Delay dose until resolved to ≤ grade 1 or baseline:" },
										{ type: "li", desc: "If resolved in ≤ 7 days from day of onset, maintain dose" },
										{ type: "li", desc: "If resolved in > 7 days from day of onset, reduce dose 1 level" },
									]},
									{ name: "Grade 4 <br/> (life threatening)", thumb: "/images/grade4.png" , sub: [
										{ type: "para", desc: "Discontinue patient from study treatment" }
									]}
								]
							},
							{
								type: "remark",
								desc: "CTCAE, Common Terminology Criteria for Adverse Events."
							}
						]
					},
					{
						header: "Cough signs and symptoms",
						sub: [
							{
								type: "li",
								sub: [
									{
										desc: "Cough is a sudden, noisy, and forceful expulsion of air from the chest, caused by irritation in the air passages, or by the reflex action of a nervous or gastric disorder<sup>41</sup>"
									},
									{
										desc: "Acute cough that starts suddenly and lasts less than 3 weeks. Persistent or chronic cough that lasts more than 8 weeks<sup>42</sup>"
									}
								]
							}
						]
					},
					{
						header: "Cough management",
						sub: [
							{
								type: "li",
								sub: [
									{
										desc: "Consider medications to minimize effects of cough, such as antitussives, expectorants, decongestants, and antihistamines<sup>41</sup>"
									},
									{
										desc: "Consult your local practice guidelines"
									}
								]
							}
						]
					},
					{
						header: "Tips for your patients<sup>42</sup>",
						sub: [
							{
								type: "li",
								sub: [
									{
										desc: "Avoid smoking and secondhand smoke"
									},
									{
										desc: "Stay hydrated, which helps thin mucus in the throat"
									},
									{
										desc: "Consider mild exercise to help open up airways"
									},
									{
										desc: "Try using cough drops"
									},
									{
										desc: "Try relaxation techniques, such as deep breathing"
									},
								]
							}
						]
					},
				]
			}
		];

		const keyPairs = {
			"pneumonitis": [["section1_title","section1_desc"],["section2_title","section2_desc"],["section3_desc"],["section4_title","section4_desc"],["section5_title","section5_desc","section5_remark"],["section6_title","section6_desc","section6_remark"],["section7_title","section7_desc","section7_remark1","section7_remark2"]],
			"lvef-decrease": [["section1_title","section1_desc"],["section2_title","section2_desc"],["section3_title","section3_desc"],["section4_title","section4_desc"]],
			"neutropenia": [["section1_desc"]],
			"embryo-fetal": [["section1_desc"]],
			"nausea": [["section1_title","section1_desc"],["section2_title","section2_desc"],["section3_title","section3_desc"],["section4_title","section4_desc"],["section5_title","section5_desc"],["section6_title","section6_desc"]],
			"vomiting": [["section1_title","section1_desc"],["section2_title","section2_desc"],["section3_title","section3_desc"],["section4_title","section4_desc"],["section5_title","section5_desc"],["section6_title","section6_desc"]],
			"constipation": [["section1_title","section1_desc"],["section2_title","section2_desc"],["section3_title","section3_desc"],["section4_title","section4_desc"],["section5_title","section5_desc"],["section6_title","section6_desc"],["section7_title","section7_desc"]],
			"appetite": [["section1_title","section1_desc"],["section2_title","section2_desc"],["section3_title","section3_desc"],["section4_title","section4_desc"],["section5_title","section5_desc"],["section6_title","section6_desc"]],
			"diarrhea": [["section1_title","section1_desc"],["section2_title","section2_desc"],["section3_title","section3_desc"],["section4_title","section4_desc"],["section5_title","section5_desc"],["section6_title","section6_desc"]],
			"anemia": [["section1_title","section1_desc"],["section2_title","section2_desc"],["section3_title","section3_desc"],["section4_title","section4_desc"],["section5_title","section5_desc"],["section6_title","section6_desc"]],
			"nc-decrease": [["section1_title","section1_desc"],["section2_title","section2_desc"],["section3_title","section3_desc"],["section4_title","section4_desc"],["section5_title","section5_desc"],["section6_title","section6_desc"],["section7_title","section7_desc"]],
			"pc-decrease": [["section1_title","section1_desc"],["section2_title","section2_desc"],["section3_title","section3_desc"],["section4_title","section4_desc"],["section5_title","section5_desc"],["section6_title","section6_desc"]],
			"wbcc-decrease": [["section1_title","section1_desc"],["section2_title","section2_desc"],["section3_title","section3_desc"],["section4_title","section4_desc"],["section5_title","section5_desc"],["section6_title","section6_desc"]],
			"fatigue": [["section1_title","section1_desc"],["section2_title","section2_desc"],["section3_title","section3_desc"],["section4_title","section4_desc"],["section5_title","section5_desc"],["section6_title","section6_desc"]],
			"alopecia": [["section1_title","section1_desc"],["section2_title","section2_desc"],["section3_title","section3_desc"],["section4_title","section4_desc"],["section5_title","section5_desc"]],
			"cough": [["section1_title","section1_desc"],["section2_title","section2_desc"],["section3_title","section3_desc"],["section4_title","section4_desc"],["section5_title","section5_desc"],["section6_title","section6_desc"]],
			"atl": [["section1_title","section1_desc"],["section2_title","section2_desc"],["section3_title","section3_desc"]]	
		};

		const splits = window.location.href.split('/');
		const object = json.filter( item => item.key == splits[splits.length - 1]);
		if (object.length == 0) {
			return ""
		}
		

		return(
			<div className="aeContainer">
				<Header urlKey={this.props.urlKey} />
				<div className="mainContainer">
					<img className="banner" src={aeBanner} />

					{
						object.map(jsonItem => {
							return (
								<div className="sectionContainer">
									<div className="headline containerMaxWidth">
										<h2 dangerouslySetInnerHTML={{ __html: jsonItem.title }}></h2>
									</div>
									<div className="bodyContent containerMaxWidth">
										{
											(this.state.res) ? (
												keyPairs[splits[splits.length - 1]].map(items => {
													console.log(items);
													return (
														<div className="subBodyItem">
															{
																items.map(item => {
																	return (
																		(item.includes("remark")) ? (
																			<div className="roundCornerRemark centerAlign">
																				<div dangerouslySetInnerHTML={{ __html: this.state.res[item] }}></div>
																			</div>
																		) : (
																			<div dangerouslySetInnerHTML={{ __html: this.state.res[item] }} ></div>
																		)
																	)
																})
															}
														</div>
													)
												})
											) : ""
											
										}
									</div>
								</div>
							);
						})
					}

					{
						(this.state.res.reference) ? (
							<div className="referenceContainer sectionContainer">
								<div className="headline containerMaxWidth">
									<h2>References</h2>
								</div>
								<div className="bodyContent containerMaxWidth" dangerouslySetInnerHTML={{ __html: this.state.res.reference }} >
								</div>
							</div>
						) : ""
					}

				</div>
				<Footer urlKey={this.props.urlKey} />
			</div>
		);
	}

}

const mapStateToProps = (state) => {
  return {

  };
}

const mapDispatchToProps = dispatch => bindActionCreators({

}, dispatch)

export default withRouter(connect(
  mapStateToProps,
  {  }
)(AeManagementItem));